<template>
	<div>
		<a-modal v-show='!ishand' id='handitemwaichu' width='34rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="width: 32rem;">
					外出工作申請
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 32rem;" class='body_lis'>
				<!--  v-if='false' -->
				<div style="margin: 0 auto;padding-top: 1.5rem;width: 90%;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<!-- <a-row>
							<a-col :span='14'>
								<a-col :span='8' class='titName'>員工姓名:</a-col>
								<a-col :span='16' class='comname'>{{formview.realname}}
									<img v-if='formview.sex == 1' :src="require('@/image/lea/man.png')" alt="">
									<img v-if='formview.sex == 2' :src="require('@/image/lea/woman.png')" alt="">
								</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='10' class='titName'>申請日期:</a-col>
								<a-col :span='14' class='comname'>{{formview.createtime}}</a-col>
							</a-col>
							<a-col :span='14'>
								<a-col :span='8' class='titName ' v-html='"部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;門:"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.department}}</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='10' class='titName ' v-html='"職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位:"'>
								</a-col>
								<a-col :span='14' class='comname'>{{formview.position}}</a-col>
							</a-col>
						</a-row> -->
						<rl @child='handff' :stas='0' :waichu='1' :fdate='form.gooutdate'></rl>
						<br>
						<a-form-model-item label='外出時間'>
							<div style="position: relative;left: 1.8rem;">
								<a-select v-model="form.begintime" class='warp_width' style='width: 8.45rem;' size="large">
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">
										{{item.text }}
									</a-select-option>
								</a-select>
								<div style="display: inline-block;margin: 0 1.5rem;">-</div>
								<a-select v-model="form.endtime" class='warp_width' style='width: 8.45rem;' size="large">
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</div>
						</a-form-model-item>

						<div>
							<a-form-model-item label='外出地點' prop='address'>
								<a-input v-model="form.address" class='warp_width' size="large"
									style='width: 20.5rem;position: relative;left: 1.8rem;' />
							</a-form-model-item>
						</div>
						<div>
							<a-form-model-item label='外出事由' prop='cause'>
								<a-input v-model="form.cause" class='warp_width' size="large"
									style='width: 20.5rem;position: relative;left: 1.8rem;' />
							</a-form-model-item>
						</div>
					</a-form-model>
					<div style="text-align: center;padding-bottom:1.5rem;">
						<button class='btn1 btnx' @click='resetForm(1)'>
							儲存
						</button>
						<button class='btn1 btn2' @click='resetForm(2)'>提交</button>
					</div>
				</div>
				<div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	export default {
		props: ['pared'],
		components: {
			rl
		},
		data() {
			return {
				fourthqty: '',
				visible: true,
				ishand: false,
				rules: {},
				formview: {
					createtime: "23/06/2021",
					department: "行政",
					position: "前台客服",
					realname: "song",
					sex: 0,
				},
				form: {
					"type": 2, //類型 1 假期申請 2 外出 3加班
					//"asktype":1,   // 1年假 2病假 3婚假 4產假 5陪產假 6喪假 7無薪休假 0其他
					// "otherasktype":"",//  其他請假形式
					"cause": "",
					address: '',
					"gooutdate": "",
					"begintime": "9:00",
					// "enddate":"2021-6-7",
					"endtime": "18:00",
					issave  :'',//1 儲存 2 提交
				},
				admintypeArrs: [],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		mounted() {
			if(this.pared.applyid){
				this.handimg()
			}
			let b = ['00', '15', '30', '45'];
			let arr = []
			for (let a = 9; a < 18; a++) {
				b.map(ev => {
					arr.push({
						text: a + ':' + ev,
						value: a + ':' + ev,
					})
				})
			}
			arr.push({
				text: '18:00',
				value: '18:00',
			})
			this.admintypeArrs = arr
		},
		methods: {
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid||'',
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						// this.formview = res.data
						this.form = res.data
						this.form.type = res.data.applytype
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handff(val) {
				this.form.gooutdate = ''
				if (val) {
					this.form.gooutdate = val
				}
			},
			handcal(ev) {
				// console.log(ev)
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			onSelect(ev) {
				console.log(ev)
			},
			onPanelChange(value, mode) {
				console.log(value, mode);
			},
			resetForm(val) {
				if(!this.form.gooutdate){
					App.oTool.warningT('請选择日期');
					return 
				}
				if(!this.form.cause){
					App.oTool.warningT('請輸入外出事由');
					return 
				}
				if(!this.form.address){
					App.oTool.warningT('請輸入外出地點');
					return 
				}
				let begin = this.form.begintime.split(':'),
				end = this.form.endtime.split(':');
				if((end[0]*1>begin[0]*1)||(end[0]*1==begin[0]*1&&end[1]*1>begin[1]*1)){
					// ||(end[0]*1>begin[0]*1&&end[1]*1>=begin[1]*1)
				}else{
					App.oTool.warningT('外出時間不正確');
					return 
				}
				
				this.form.issave = val 
				this.form.token = this.$store.state.token;
				// this.$refs[formName].resetFields();
				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#handitemwaichu {

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.titName {
			font-size: .8rem !important;
			color: #000;
			height: 2rem;
		}

		.comname {
			font-size: .8rem !important;
		}

		.ant-modal {
			top: 12vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: .8rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1.4rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
